module.exports = __webpack_public_path__ + "static/logo-icon-7ce5f8fd83bd2cbbafeaca91535ed9e7.png";